import { format } from 'date-fns';
import { is } from 'date-fns/locale';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { useStore } from 'models/Provider';

import { tvinnaStatusChoices } from './constants';

export const PromoteTvinnaExample = observer(({ state, boardState }) => {
  const { current: company } = useStore();
  const { title, description } = state.data;
  const status = tvinnaStatusChoices.find((c) => c.value === boardState.status).label;
  const created = format(new Date(), 'd. MMM yyyy', { locale: is });

  return (
    <TvinnaContainer>
      <TvinnaHeader>
        <Box maxW={780} w="100%" h={80} flex justifyContent="space-between" alignItems="center">
          <div style={{ marginTop: 4 }}>
            <svg viewBox="0 0 108 24.999" width="150px" fill="#fff">
              <path d="M30.009 0l-2.003 12.08h-0.12L25.908 0h-5.793l5.114 24.999h5.433L35.813 0H30.009z" />
              <path d="M6.012 24.999h5.97V6.019h6.033V0H0v6.019h6.012V24.999z" />
              <path d="M43.977 24.999V0h-5.97v24.999H43.977z" />
              <path d="M61.015 0v24.327L52.367 0h-5.353v24.999h5.97v-7.933h0.121l2.53 7.933h11.413V0H61.015z" />
              <path d="M98.107 24.999l2.003-12.08h0.12l1.978 12.08H108L102.886 0h-5.433l-5.15 24.999H98.107z" />
              <path d="M84.015 0v24.327L75.367 0h-5.353v24.999h5.97v-7.933h0.121l2.53 7.933h11.413V0H84.015z" />
            </svg>
          </div>
        </Box>
      </TvinnaHeader>
      <TvinnaContent>
        <Box flex justifyContent="space-between" alignItems="center">
          <TvinnaContentTitle>{title}</TvinnaContentTitle>
          <img src={company.info.logo} alt={company.info.name} style={{ maxHeight: 40 }} />
        </Box>
        <TvinnaSplitter style={{ marginTop: 30 }} />
        <Box flex alignItems="center" h={40}>
          <TvinnaCompanyName>{company.info.companyName}</TvinnaCompanyName>
          <TvinnaJobProperty>{created}</TvinnaJobProperty>
          <TvinnaJobProperty>{status}</TvinnaJobProperty>
        </Box>
        <TvinnaSplitter />
        <div style={{ marginTop: 40 }} dangerouslySetInnerHTML={{ __html: description }} />

        <TvinnaSplitter />
        <TvinnaApplyButton>Sækja um starf</TvinnaApplyButton>

        <TvinnaExtraInfo>
          <div style={{ fontWeight: 600 }}>Upplýsingar fyrir umsækjendur</div>
          <div dangerouslySetInnerHTML={{ __html: boardState.extraInfo }} />
        </TvinnaExtraInfo>
      </TvinnaContent>
    </TvinnaContainer>
  );
});

const TvinnaCompanyName = styled.div({
  color: '#f05f51',
  fontWeight: 600,
});

const TvinnaJobProperty = styled.div({
  paddingLeft: 20,
  marginLeft: 20,
  borderLeft: '1px solid #d8d8d8',
});

const TvinnaExtraInfo = styled.div({
  backgroundColor: '#f8f8f8',
  padding: 20,
  margin: '20px 0',
  color: '#1f1f1f',
});

const TvinnaApplyButton = styled.div({
  backgroundColor: '#0dc1bb',
  padding: '10px 15px',
  marginTop: 30,
  fontSize: 20,
  width: 180,
  display: 'inline-block',
  textShadow: '0 1px 0 rgba(0,0,0,.25)',
  borderRadius: '5px',
  color: '#fff',
  textAlign: 'center',
  lineHeight: '28px',
});

const TvinnaHeader = styled.div({
  background: '#f05f51',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  height: 80,
  fontWeight: 600,
  padding: '0 20px',
});

const TvinnaContainer = styled.div({
  '*': {
    fontFamily: '"Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif !important',
  },
  color: '#fff',
});

const TvinnaContent = styled.div({
  background: '#fff',
  color: 'rgb(31, 31, 31)',
  margin: '30px auto',
  borderRadius: '5px',
  padding: '50px 80px 30px',
  maxWidth: 780,
  'ul li': {
    padding: '2px 0',
  },
});

const TvinnaContentTitle = styled.div({
  fontSize: 24,
  fontWeight: 600,
});

const TvinnaSplitter = styled.div({
  background: '#d8d8d8',
  height: '1px',
  width: '100%',
});
